import React, { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { apiClient } from '../../services/api';

const STATUS_MESSAGES: Record<string, string> = {
    past_due:  'Your payment failed. Update your payment method to restore full access.',
    unpaid:    'Your account is unpaid. Update your payment method or your account will be deleted.',
    paused:    'Your subscription is paused. Your account is in read-only mode.',
};

const RestrictedBanner: React.FC = () => {
    const [status, setStatus] = useState<string | null>(null);
    const [portalLoading, setPortalLoading] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        apiClient.get('/billing/status')
            .then(r => {
                const s = r.data?.status;
                if (s && STATUS_MESSAGES[s]) setStatus(s);
            })
            .catch(() => {});
    }, []);

    const handlePortal = async () => {
        setPortalLoading(true);
        try {
            const res = await apiClient.post('/billing/portal', { return_url: window.location.href });
            if (res.data?.portal_url) window.location.href = res.data.portal_url;
        } catch { /* silent */ } finally { setPortalLoading(false); }
    };

    if (!status || dismissed) return null;

    return (
        <div style={{
            position: 'sticky', top: 0, zIndex: 999,
            background: status === 'paused' ? 'var(--warning, #f59e0b)' : 'var(--danger, #dc2626)',
            color: '#fff',
            padding: '10px 20px',
            display: 'flex', alignItems: 'center', gap: 12,
            fontSize: '0.875rem', fontWeight: 500,
        }}>
            <AlertTriangle size={16} style={{ flexShrink: 0 }} />
            <span style={{ flex: 1 }}>{STATUS_MESSAGES[status]}</span>
            {status !== 'paused' && (
                <button onClick={handlePortal} disabled={portalLoading} style={{
                    background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.4)',
                    color: '#fff', padding: '4px 14px', borderRadius: 6, cursor: 'pointer',
                    fontWeight: 600, fontSize: '0.82rem', whiteSpace: 'nowrap',
                }}>
                    {portalLoading ? 'Loading…' : 'Update Payment'}
                </button>
            )}
            <button onClick={() => setDismissed(true)} style={{
                background: 'none', border: 'none', color: '#fff', cursor: 'pointer',
                display: 'flex', alignItems: 'center', opacity: 0.7, padding: 4,
            }}>
                <X size={14} />
            </button>
        </div>
    );
};

export default RestrictedBanner;
